import script from "./NewsPageFavorite.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageFavorite.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageFavorite.vue?vue&type=style&index=0&id=10c4f08d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c4f08d"]])

export default __exports__